import { render, staticRenderFns } from "./viewMainFee.vue?vue&type=template&id=cffd8586&scoped=true"
import script from "./viewMainFee.vue?vue&type=script&lang=js"
export * from "./viewMainFee.vue?vue&type=script&lang=js"
import style0 from "./viewMainFee.vue?vue&type=style&index=0&id=cffd8586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffd8586",
  null
  
)

export default component.exports